export class RegionNotFoundError extends Error {
  constructor(public readonly connectRegion: string) {
    super(`Global region ${connectRegion} not found`);
    this.name = 'RegionNotFoundError';
  }
}

export function isRegionNotFoundError(err: unknown): err is RegionNotFoundError {
  return err instanceof RegionNotFoundError;
}
